<div id="phone" #phonepan fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">



  <mat-dialog-title fxLayoutAlign="center ">{{'clientphoneComponent.changePhone' | translate}} </mat-dialog-title>


  <form class="layout-padd-2" [formGroup]="phoneForm" #dirPhoneForm="ngForm"
    (ngSubmit)="submitNewPhone(dirPhoneForm, phonepan)">

    <div fxLayout="column" class="full-w" style="padding-top:20px ;" fxLayoutGap="40px">

      <mat-form-field>

        <input matInput #autoCompleteCountry placeholder="{{'clientphoneComponent.country' | translate}}" [matAutocomplete]="autoCountries"
          formControlName="country_name" autocomplete="none|false|no" (blur)='error$=null'  >

        <mat-autocomplete #autoCountries="matAutocomplete" class="phone" (optionSelected)="clearFilter()" >

          <ng-container *ngIf="!loaders.countries && filteredCountries" >

            <mat-option *ngFor="let country of filteredCountries" [value]="country.name"
              (onSelectionChange)="onSelectCountry(country)">


              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img *ngIf="country.flag" src="data:image/png;base64,{{country.flag}}"  class="h-16">
                <div *ngIf="!country.flag">
                  <mat-icon>outlined_flag</mat-icon>
                </div>
                <span>{{country.name }}</span>
              </div>



            </mat-option>

          </ng-container>

          <mat-option *ngIf="loaders.countries">
            <mat-spinner diameter="20"></mat-spinner>
          </mat-option>

          <mat-option *ngIf="!loaders.countries && !filteredCountries">
            <span>{{'clientphoneComponent.noResult' | translate}} </span>
          </mat-option>

        </mat-autocomplete>

        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="phoneForm.controls['country_name'].errors?.required">
          <span class="mat-caption">{{'clientphoneComponent.countryRequired' | translate}}</span>
        </mat-error>

      </mat-form-field>

      <mat-form-field  >
        <mat-label>{{'clientphoneComponent.newNumber' | translate}} </mat-label>

        <input matInput type="firstname" (keydown.space)="$event.preventDefault()" placeholder="{{'clientphoneComponent.newNumber' | translate}}"
          formControlName="phone" (blur)='error$=null'>

        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="phoneForm.controls['phone'].errors?.required">
          <span class="mat-caption">{{'clientphoneComponent.phonerequired' | translate}} </span>
        </mat-error>
        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="phoneForm.controls['phone'].errors?.pattern">
          <span class="mat-caption">{{'clientphoneComponent.invalidFormat' | translate}}</span>
        </mat-error>

        <!-- <mat-hint *ngIf="phoneForm.value.id_country &&getIndicatif()">
          <span > format conseillé ( {{getIndicatif()}} XXX XXX ) </span>
        </mat-hint> -->
      </mat-form-field>


      <!-- error -->
      <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn"
        *ngIf="error$ === 'errphoneinvalid' || error$ === 'errphonealreadytaken' || error$ === 'errnomobile'">
        <div fxFlex="10%" fxLayoutAlign="start center">
          <mat-icon>phone</mat-icon>
        </div>

        <div fxFlex fxLayoutAlign="center center" class="text-center">

          <span class="mat-subheading-2" *ngIf="error$ === 'errphonealreadytaken'">
            {{'clientphoneComponent.phoneUsed' | translate}}</span>
          <span class="mat-subheading-2" *ngIf="error$ === 'errphoneinvalid'">
            {{'clientphoneComponent.phonenogood' | translate}}</span>
          <span class="mat-subheading-2" *ngIf="error$ === 'errnomobile'">
            {{'clientphoneComponent.phoneismobile' | translate}} </span>
        </div>

      </mat-card>


    </div>


    <!--  btn bottom -->
    <div class="layout-padd positionBottom" fxLayoutGap="10px" fxflex>

      <button cdkFocusInitial type="submit" mat-raised-button color="primary" class=" rounded-button" fxFlex
        angulartics2On="click" angularticsAction="submitNewMobilForm" angularticsCategory="phoneAccountDial">
        <span class="mat-title">{{"main.word.update"|translate}}</span>
      </button>

      <button (click)="closeDial()" mat-stroked-button class="dark-ico rounded-button" fxFlex angulartics2On="click"
        angularticsAction="closeNewMobilForm" angularticsCategory="phoneAccountDial">
        <span class="mat-title">{{ "cancel_button"|translate}}</span>
      </button>



    </div>




  </form>





  <app-popup-loader [flagLoading]="loaders.countries" [size]="30">
  </app-popup-loader>


  <app-popup-loader [flagLoading]="loaders.forms" [size]="30" [statusMessage]="statusMessage">
  </app-popup-loader>

</div>
